import React from "react";
import YMLImg from "../../../assets/YML.png";
// import MovieAppImg from "../../../assets/movie_app.png";
import SukiImg from "../../../assets/suki.png";
import GithubProfileHub from "../../../assets/githubprofilehub.png";
import GGImg from "../../../assets/Galaxy_Gaming.png";
// import JgiriImg from "../../../assets/Jgiri.png";
import chessGameImg from "../../../assets/chess-game.png";
import GoogleCalendar from "../../../assets/google-calendar-clone-1.png";

import "./Projects.css";

const Projects = ({ theme }) => {
  const projectsData = [
    {
      id: 1,
      img: YMLImg,
      name: "Digital Marketing agency website",
      content: "A website for a digital marketing agency",
      live_link: "https://yellomonkey.com/",
    },
    {
      id: 2,
      img: GoogleCalendar,
      name: "Google Calendar",
      content:
        "Created a Google Calendar clone that allows users to view Indian holidays and seamlessly create and store personalized events.",
      live_link: "https://google-calendar-clone-abc.vercel.app/",
    },
    {
      id: 3,
      img: SukiImg,
      name: "3D Art Gallery",
      content: "A 3D art gallery website",
      live_link: "https://sukiviolet-gallery.netlify.app/",
    },
    {
      id: 4,
      img: GithubProfileHub,
      name: "Github profile finder",
      content:
        "A nicer look at your GitHub profile and repository stats with data visualizations of your top languages and stars.",
      live_link: "https://github-profile-hub.netlify.app/",
    },
    {
      id: 5,
      img: GGImg,
      name: "3D NFT Landing Page",
      content: "A 3D NFT landing page",
      live_link: "https://galaxy-gg.netlify.app/",
    },
    // {
    //   id: 6,
    //   img: JgiriImg,
    //   name: "Hardware Agency website",
    //   content: "A hardware dealer stores website.",
    //   live_link: "https://jgiri-sons-online.vercel.app/",
    // },
    {
      id: 6,
      img: chessGameImg,
      name: "Chess Game",
      content: "A 2-player simple chess game",
      live_link: "https://chess-game-orpin.vercel.app/",
    },
  ];

  return (
    <div className="col-span-1 lg:col-span-2">
      <div className="card compact bg-base-100 shadow bg-opacity-40">
        <div className="card-body">
          <div className="mx-3 mb-2">
            <h5 className="card-title text-base-content opacity-70">
              My Projects
            </h5>
            <p>
              Check out some of my projects, built with love and dedication,
              each one reflecting attention to detail.
            </p>
          </div>

          <div className="card shadow-lg compact bg-base-100 cursor-pointer">
            <div className="p-6 h-full w-full">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
                {projectsData.map((project) => (
                  <div key={project.id} className="w-full h-full !block">
                    <div
                      className="project-item style-two wow fadeInUp delay-0-3s h-full !flex !flex-col"
                      style={{ gridTemplateRows: "100px" }}
                    >
                      <div className="project-image !h-fit">
                        <img
                          src={project.img}
                          alt="Project"
                          width="300"
                          height="250"
                          className="rounded-lg !h-fit !object-cover"
                        />
                        <a
                          href={project.live_link}
                          className="details-btn !flex !items-center !justify-center"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth={0}
                            viewBox="0 0 448 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"></path>
                          </svg>
                        </a>
                      </div>
                      <div className="project-content">
                        <h3 className={theme === "dark" ? "text-white" : ""}>
                          {project.name}
                        </h3>
                        <p>{project.content}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
